<div class="outerBar">
    <div [style.width.%]="percent" class="inlineBar">
        <div [ngSwitch]="format">
            <p *ngSwitchCase="'default'" class="textStyle">{{ value }}</p>
            <p *ngSwitchCase="'number'" class="textStyle">{{ value | number: '1.2-2' }}</p>
            <p *ngSwitchCase="'currency'" class="textStyle">
                {{ value | currency: 'USD':'symbol':'1.0-0' }}
            </p>
            <p *ngSwitchCase="'percent'" class="textStyle">{{ value }}%</p>
        </div>
    </div>
</div>
